import React, { useState, useEffect } from 'react'
import { __constants, __snackBarSeverity } from '../../constants';
import moment from 'moment';
import mainContext from '../../contexts/mainContext';
import { getHelpSupportListing, updateHelpSupportStatus } from '../../Controllers/Help&Support';
import styled from '@emotion/styled';
import { Button, Divider, Pagination } from '@mui/material';
import SearhcBar from './SearchBar';
import { Support } from '@mui/icons-material';
import ReportDetail from './ReportDetail';
import { getReportListing, updateReportStatus } from '../../Controllers/Reports';

export default function ReportList() {
  const { setSnackBar, setProfileNavTitle, setPageload } = React.useContext(mainContext); /* App State */
  const [state, setState] = useState({ /* Component State */
    reports: {},
    total: 0,
    page: 1,
    limit: 8,
    index: -1,
    selectedReport: {},
    openDetails: false
  })
  const [filterState, setFilterState] = React.useState({});

  useEffect(() => {
    setProfileNavTitle("Reports") /* Set TopNav Title */
    fetchReports(state.page)
    // eslint-disable-next-line
  }, [])

  const callSnackBar = (msg, type) => { /* Alert for User */
    setSnackBar({
      status: true,
      text: msg,
      severity: __snackBarSeverity[type]
    });
  }

  const fetchReports = async (page, isClear) => { /* Get Categories and sub categories */
    let params = { page }
    if (!isClear)
      params = { page, ...filterState }
    setPageload(true)
    const res = await getReportListing(params)
    setPageload(false)
    if (res.data.status === 200) {
      let newList = {}
      res.data.data.reports.forEach((object) => { /* Formating user data */
        let date = moment(object.createdAt).format('YYYY-MM-DD')
        object.userInfo.some((userObject) => {
          if (userObject.user.user === "reportFrom")
            object.reportFrom = userObject.user
          else
            object.reportFor = userObject.user
        })
        delete object.userInfo
        newList[date] = newList[date] ? newList[date] : []
        newList[date].push(object)
      })
      setState({ ...state, reports: newList, total: res.data.data.total })
    } else {
      callSnackBar(res.data.errors[0].message, "error")
    }
  }

  const handleStatus = async (index, status, data) => {
    if (data.status === "Unread") {
      const res = await updateReportStatus(data._id, { status })
      if (res.data.status === 200) {
        let newDate = moment(data.createdAt).format('YYYY-MM-DD')
        let temp = { ...state.reports }
        temp[newDate][index].status = status
        setState({ ...state, reports: temp })
        handleView(data, index)
      } else {
        callSnackBar(res.data.errors[0].message, "error")
      }
    } else {
      handleView(data, index)
    }
  }

  const handleView = (data, index) => {
    setState({ ...state, openDetails: true, selectedReport: data, index: index })
  }

  const handleCb = (status, date, index) => {
    let newDate = moment(date).format('YYYY-MM-DD')
    let temp = { ...state.reports }
    temp[newDate][index].status = status
    setState({ ...state, reports: temp, openDetails: false })
  }

  return (
    <>
      <SearhcBar filterState={filterState} setFilterState={setFilterState} callFunction={fetchReports} />
      <Container className='scrollbar'>
        <Body>
          {Object.entries(state.reports).map((list) =>
            <>
              <Date>{moment(list[1][0].createdAt).format("DD MMM, YYYY")}</Date>
              <Divider className='divider-gap' />
              <List>
                <div className="header">Status</div>
                <div className="header">Report No.</div>
                <div className="header">Email (Report From)</div>
                <div className="header">Role (Report From)</div>
                <div className="header">Email (Report For)</div>
                <div className="header">Role (Report For)</div>
                <div className="header"></div>
              </List>
              <Divider className='divider-gap' />
              {list[1].map((object, index) =>
                <>
                  <List key={object._id}>
                    <div>
                      <div className={object.status === "Unread" ? "list_card_status status_inactive" : object.status === "Resolved" ? "list_card_status status_active" : "list_card_status status_sleeping"}>{object.status}</div>
                    </div>
                    <div>
                      {object.reportNo}
                    </div>
                    <div>
                      {object.reportFrom.email}
                    </div>
                    <div>
                      {object.reportFrom.role}
                    </div>
                    <div>
                      {object.reportFor.email}
                    </div>
                    <div>
                      {object.reportFor.role}
                    </div>
                    <button className="list_card_view_btn" onClick={() => { handleStatus(index, "Unresolved", object) }}>View</button>
                  </List>
                </>
              )}

              <Divider className='divider-gap' />
            </>
          )}
          {Object.entries(state.reports).length === 0 && <div className='no-record'><span>No Record Found</span></div>}
        </Body>
      </Container>
      {
        Object.entries(state.reports).length > 0 &&
        <>
          <Pagination count={Math.ceil(state.total / __constants.listingLimit)} color="primary" shape="rounded" onChange={(e, page) => { fetchReports(page) }} />
          <br />
        </>
      }

      <ReportDetail
        open={state.openDetails}
        handleClose={() => setState({ ...state, openDetails: false })}
        data={state.selectedReport}
        cb={handleCb}
        index={state.index}
      />
    </>
  )
}

const Container = styled("div")`
  .divider-gap{
        margin: 0.5rem 0;
  }
  button{
    text-transform: none;
  }
  overflow-x: auto;
  margin-bottom:10px;

`;

const Body = styled("div")`
  height: 80vh;
  width:1100px;
  margin-bottom:10px;
`;

const Date = styled("div")`
  margin:20px 0px 10px 0;
  font-weight : bold;
`;

const List = styled("div")`
.header{
    font-family: "semi-bold";
}
  margin-top: 1rem;
  display: grid;
  column-gap: 0.7rem;
  grid-template-columns: minmax(0,1fr) minmax(0,1fr) minmax(0,2.3fr) minmax(0,1.5fr) minmax(0,2.3fr) minmax(0,1.5fr) minmax(0,0.8fr);
  align-items: center;
  font-size:14px
`;


